import { requestAPI } from 'utils/api'

export const uploadFile = (params: FormData) => {
  return requestAPI({
    method: 'POST', url: '/s3/upload', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readExcelFile = (params: { objKey: string }) => {
  return requestAPI({
    method: 'POST', url: '/s3/read-xlsx', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const downloadFile = (params: { objKey: string }) => {
  return requestAPI({
    method: 'POST', url: '/s3/download', params, responseType: 'BLOB'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const sendPushMessage = (params: any) => {
  return requestAPI({
    method: 'POST', url: '/fcm/push', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readContentsOnOff = () => {
  return requestAPI({
    method: 'GET', url: '/management/contentsonoff'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateContentsOnOff = (groupName: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/contentsonoff/${groupName}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createMaintenanceSchedule = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/maintenance/schedule', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readMaintenanceSchedule = () => {
  return requestAPI({
    method: 'GET', url: '/management/maintenance/schedule'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateMaintenanceSchedule = (scheduleId: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/maintenance/schedule/${scheduleId}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteMaintenanceSchedule = (scheduleId: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/maintenance/schedule/${scheduleId}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readLeagueInvalidated = () => {
  return requestAPI({
    method: 'GET', url: '/management/maintenance/leagueinvalidated'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createMessageNotice = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/message/notice', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readMessageNotice = () => {
  return requestAPI({
    method: 'GET', url: '/management/message/notice'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateMessageNotice = (noticeId: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/message/notice/${noticeId}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteMessageNotice = (noticeId: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/message/notice/${noticeId}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createSystemNotice = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/message/systemnotice', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readSystemNotice = () => {
  return requestAPI({
    method: 'GET', url: '/management/message/systemnotice'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateSystemNotice = (noticeId: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/message/systemnotice/${noticeId}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteSystemNotice = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/message/systemnotice/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createTouPP = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/message/toupp', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readTouPP = () => {
  return requestAPI({
    method: 'GET', url: '/management/message/toupp'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateLiveTouPP = (id: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/message/toupp/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}


export const createOperatorPayment = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/message/operator', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readOperatorPayment = () => {
  return requestAPI({
    method: 'GET', url: '/management/message/operator'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateOperatorPayment = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/message/operator/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteOperatorPayment = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/message/operator/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createOneLinkSchedule = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/onelink', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readOneLinkSchedule = () => {
  return requestAPI({
    method: 'GET', url: '/management/onelink'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateOneLinkSchedule = (onelinkId: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/onelink/${onelinkId}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteOneLinkSchedule = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/onelink/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}


export const readPushSchedule = () => {
  return requestAPI({
    method: 'GET', url: '/management/push'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deletePushSchedule = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/push/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const validatePushSchedule = (params: any) => {
  return requestAPI({
    method: 'POST', url: `/management/push/validate`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const uploadPushSchedule = (params: { [x: string]: any }[]) => {
  return requestAPI({
    method: 'POST', url: '/management/push', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createGateway = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/gateway', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readGateways = () => {
  return requestAPI({
    method: 'GET', url: '/management/gateway'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readGatewaysV2 = (params?: any) => {
  return requestAPI({
    method: 'GET', url: '/management/gateway/v2', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateGateway = (params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/gateway`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateGatewayV2 = (type: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/gateway/${type}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteGateway = (version: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/gateway/${version}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createGatewayOverride = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/gatewayoverride', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readGatewayOverrides = () => {
  return requestAPI({
    method: 'GET', url: '/management/gatewayoverride'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteGatewayOverride = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/gatewayoverride/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}
export const createBlacklist = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/blacklist', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readBlacklists = () => {
  return requestAPI({
    method: 'GET', url: '/management/blacklist'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteBlacklist = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/blacklist/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createWhitelist = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/whitelist', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readWhitelists = () => {
  return requestAPI({
    method: 'GET', url: '/management/whitelist'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteWhitelist = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/whitelist/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createStaging = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/staging', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readStaging = () => {
  return requestAPI({
    method: 'GET', url: '/management/staging'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteStaging = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/staging/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const validateLeagueConfig = (params: any) => {
  return requestAPI({
    method: 'POST', url: `/management/league/config/validate`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const importLeagueConfig = (params: any) => {
  return requestAPI({
    method: 'POST', url: '/management/league/config/import', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readLeagueConfig = () => {
  return requestAPI({
    method: 'GET', url: '/management/league/config'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createLeagueData = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/league/data', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readLeagueData = () => {
  return requestAPI({
    method: 'GET', url: '/management/league/data'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateLeagueData = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/league/data/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteLeagueData = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/league/data/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createLeagueSchedule = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/league/schedule', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readLeagueSchedule = () => {
  return requestAPI({
    method: 'GET', url: '/management/league/schedule'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateLeagueSchedule = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/league/schedule/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateLeagueScheduleState = (id: any, type: any, newValue: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/league/schedule/state/${id}`, params: { type, newValue }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteLeagueSchedule = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/league/schedule/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateLeagueForceInvalidate = (id: any, leagueName: any, batchId?: any, desc?: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/league/schedule/invalidate/${id}`, params: { leagueName, batchId, desc }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createAttendanceRewardsConfig = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/attendance/reward/config', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readAttendanceRewardsConfig = (optionOnly?: boolean) => {
  return requestAPI({
    method: 'GET', url: '/management/attendance/reward/config', params: { optionOnly }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateAttendanceRewardsConfig = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/attendance/reward/config/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteAttendanceRewardsConfig = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/attendance/reward/config/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createAttendance = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/attendance', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readAttendance = () => {
  return requestAPI({
    method: 'GET', url: '/management/attendance'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateAttendance = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/attendance/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteAttendance = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/attendance/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createBingoBallRewards = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/bingoball/rewards', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readBingoBallRewards = () => {
  return requestAPI({
    method: 'GET', url: '/management/bingoball/rewards'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateBingoBallRewards = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/bingoball/rewards/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteBingoBallRewards = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/bingoball/rewards/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createBingoBallLeagues = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/bingoball/leagues', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readBingoBallLeagues = () => {
  return requestAPI({
    method: 'GET', url: '/management/bingoball/leagues'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateBingoBallLeagues = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/bingoball/leagues/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteBingoBallLeagues = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/bingoball/leagues/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readBingoBallTemplates = () => {
  return requestAPI({
    method: 'GET', url: '/management/bingoball/templates'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createBingoBallSchedule = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/bingoball/schedule', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readBingoBallSchedule = () => {
  return requestAPI({
    method: 'GET', url: '/management/bingoball/schedule'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateBingoBallSchedule = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/bingoball/schedule/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteBingoBallSchedule = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/bingoball/schedule/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createCashMine = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/cashmine', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readCashMine = () => {
  return requestAPI({
    method: 'GET', url: '/management/cashmine'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateCashMine = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/cashmine/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteCashMine = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/cashmine/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createEventData = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/event/data', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const duplicateEventData = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/event/duplicate', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readEventData = (type?: string) => {
  return requestAPI({
    method: 'GET', url: '/management/event/data', params: { type }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateEventData = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/event/data/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateEventGroup = (group_id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/event/group/${group_id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteEventData = (id: any, targetMasterId?: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/event/data/${id}`, params: { targetMasterId }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createEventMultiRound = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/event/multiround', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateEventMultiRound = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/event/multiround/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteEventMultiRound = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/event/multiround/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createEventRoulette = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/event/roulette', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateEventRoulette = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/event/roulette/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteEventRoulette = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/event/roulette/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createMission = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/mission', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readMission = () => {
  return requestAPI({
    method: 'GET', url: '/management/mission'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateMission = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/mission/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteMission = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/mission/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createMissionSeasonal = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/seasonal', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateMissionSeasonal = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/seasonal/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteMissionSeasonal = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/seasonal/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createMissionSub = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/mission/sub', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateMissionSub = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/mission/sub/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteMissionSub = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/mission/sub/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}


export const createSeasonalChapter = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/seasonal/chapter', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateSeasonalChapter = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/seasonal/chapter/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteSeasonalChapter = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/seasonal/chapter/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createMiniGame = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/minigame', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readMiniGame = (type?: any) => {
  return requestAPI({
    method: 'GET', url: '/management/minigame', params: { type }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const upsertMiniGameRoulettes = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/minigame/roulette', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateMiniGame = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/minigame/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteMiniGame = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/minigame/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createMinigameSub = (rule: any, params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: `/management/minigame/sub/${rule}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateMinigameSub = (rule: any, id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/minigame/sub/${rule}-${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteMinigameSub = (rule: any, id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/minigame/sub/${rule}-${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readSegmentOptions = () => {
  return requestAPI({
    method: 'GET', url: '/management/segment/options'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}


export const readEventSegment = () => {
  return requestAPI({
    method: 'GET', url: '/management/segment'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createEventSegment = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/segment', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateEventSegment = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/segment/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteEventSegment = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/segment/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readABTestOptions = () => {
  return requestAPI({
    method: 'GET', url: '/management/abtest/options'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const validateABTestData = (params: FormData) => {
  return requestAPI({
    method: 'POST', url: '/management/abtest/data/validate', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createABTestData = (params: FormData) => {
  return requestAPI({
    method: 'POST', url: '/management/abtest/data', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteABTestData = (testCode: any, dataCode: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/abtest/data/${testCode}/${dataCode}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readABTestSchedules = () => {
  return requestAPI({
    method: 'GET', url: '/management/abtest/schedule'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createABTestSchedule = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/abtest/schedule', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateABTestSchedule = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/abtest/schedule/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteABTestSchedule = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/abtest/schedule/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readPromoCoupon = () => {
  return requestAPI({
    method: 'GET', url: '/management/promocoupon'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createPromoCoupon = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/promocoupon', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updatePromoCoupon = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/promocoupon/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deletePromoCoupon = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/promocoupon/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readPromoInvite = () => {
  return requestAPI({
    method: 'GET', url: '/management/invitecontrol'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createPromoInvite = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/invitecontrol', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updatePromoInvite = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/invitecontrol/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deletePromoInvite = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/invitecontrol/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readPromoQuest = () => {
  return requestAPI({
    method: 'GET', url: '/management/invitequest'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createPromoQuest = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/invitequest', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updatePromoQuest = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/invitequest/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deletePromoQuest = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/invitequest/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readReceived = (type: any, params: any) => {
  return requestAPI({
    method: 'GET', url: `/management/coupon/received/${type}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createApolloTour = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/prizeranking/data', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const duplicateApolloTour = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/prizeranking/duplicate', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readApolloTour = () => {
  return requestAPI({
    method: 'GET', url: '/management/prizeranking/data'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateApolloTour = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/prizeranking/data/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteApolloTour = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/prizeranking/data/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createPrizeRankingSub = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/prizeranking/sub', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updatePrizeRankingSub = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/prizeranking/sub/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deletePrizeRankingSub = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/prizeranking/sub/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}


export const readModerationPictures = () => {
  return requestAPI({
    method: 'GET', url: '/management/moderationpictures'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateModerationPictures = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/moderationpictures/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readWinnersTipUser = (account_ulid: any) => {
  return requestAPI({
    method: 'GET', url: '/management/winnerstip/user', params: { account_ulid }
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const readWinnersTip = () => {
  return requestAPI({
    method: 'GET', url: '/management/winnerstip'
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const createWinnersTip = (params: { [x: string]: any }) => {
  return requestAPI({
    method: 'POST', url: '/management/winnerstip', params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const updateWinnersTip = (id: any, params: any) => {
  return requestAPI({
    method: 'PATCH', url: `/management/winnerstip/${id}`, params
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}

export const deleteWinnersTip = (id: any) => {
  return requestAPI({
    method: 'DELETE', url: `/management/winnerstip/${id}`
  }).then((result) => {
    return result.data
  }).catch((error) => { throw JSON.parse(error) })
}